import { Guid } from '@constellation-mutual/guid';
import axios, { AxiosResponse, AxiosRequestConfig } from 'axios';
import store from '@/store/index';
import { Quote } from './Quotes';
import { Provider } from './Providers';

// This is an abbreviated version of InsureCAREteams' `ApplicationResponse.Serialized`.
export class Application {
     public constructor(data: Application) {
          Object.assign(this, data);
     }

     public providers: Provider[];
     public quoteId: Guid;
     public timestampCreated: string;

     public static mock(): Application {
          return new Application({
               providers: [Provider.mock(), Provider.mock()],
               quoteId: Quote.mock().id,
               timestampCreated: '2019-03-13T15:20:54.154Z',
          });
     }
}

// This is an abbreviated version of InsureCAREteams' `ApplicationService`.
export class ApplicationsService {
     public constructor(private readonly _baseUrl: string) {}

     public async readApplicationsForUserId(): Promise<Application[]> {
          const response: AxiosResponse = await axios.get(
               '/users/current/applications/',
               this.createAxiosRequestConfig(),
          );

          return Array.isArray(response.data)
               ? response.data
                      .map(item => new Application(item))
                      // Sort newest first.
                      .sort(
                           (a: Application, b: Application): number =>
                                new Date(b.timestampCreated).getTime() -
                                new Date(a.timestampCreated).getTime(),
                      )
               : [];
     }

     private createAxiosRequestConfig(): AxiosRequestConfig {
          const config: AxiosRequestConfig = {
               baseURL: this._baseUrl,
          };
          return config;
     }
}

const Applications = new ApplicationsService(process.env.VUE_APP_DAX_API_URI);
export default Applications;
